// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// import Vacancies from "../OpportunitiesPage/OpportunitiesTabs/Vacancies";
// import MartimeCareers from "../OpportunitiesPage/OpportunitiesTabs/MartimeCareers";
// import MartimeStudies from "../OpportunitiesPage/OpportunitiesTabs/MartimeStudies";
// import Cadetship from "../OpportunitiesPage/OpportunitiesTabs/Cadetship";
// import SupplyChainManagement from "../OpportunitiesPage/OpportunitiesTabs/SupplyChainManagement";
// import CadetshipTraining from "../OpportunitiesPage/OpportunitiesTabs/CadetshipTraining";
// import RFQSubmissions from "../OpportunitiesPage/OpportunitiesTabs/RFQSubmissions";
// import FleetManagement from "../OpportunitiesPage/OpportunitiesTabs/FleetManagement";
// import OpportunitiesLegislation from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesLegislation";
// import OpportunitiesSBDForms from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesSBDForms";
// import OpportunitiesGeneralConditions from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesGeneralConditions";
// import OpportunitiesCodeOFConduct from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesCodeOFConduct";

// import VerifyForm from "../Verify";
// import ManageAccess from "./ManageAccess";
// import AdminF from "./AdminF";
// import UsesrRoles from "./UsesrRoles";

// // Mapping sections to components
// const sectionComponents = {
//   "VerifyForm": <VerifyForm />,
//   "Manage-Access": <ManageAccess />,
//   "mn-veri": <AdminF />,
//   "vacancies": <Vacancies />,
//   "maritime-careers": <MartimeCareers />,
//   "cadetship": <Cadetship />,
//   "CadetshipTraining": <CadetshipTraining />,
//   "supply-chain": <SupplyChainManagement />,
//   "maritime-studies": <MartimeStudies />,
//   "RFQ-Submissions": <RFQSubmissions />,
//   "Fleet-Management": <FleetManagement />,
//   "Opportunities-Legislation": <OpportunitiesLegislation />,
//   "Usesr-Roles": <UsesrRoles />,
//   "Opportunities-GeneralConditions": <OpportunitiesGeneralConditions />,
//   "Opportunities-CodeOFConduct": <OpportunitiesCodeOFConduct />,
// };

// function VerifyAdminTab() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const queryParams = new URLSearchParams(location.search);
//   const initialSection = queryParams.get("section") || "VerifyForm";

//   const [currentSection, setCurrentSection] = useState(initialSection);
//   const [role, setRole] = useState(null); // null until loaded

//   // ✅ Fetch user role from localStorage (set after login)
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);
//         setRole(user.role || "NormalUser");
//       } catch (err) {
//         console.error("Failed to parse user from localStorage", err);
//         setRole("NormalUser");
//       }
//     } else {
//       setRole("NormalUser");
//     }
//   }, []);

//   const handleClick = (section) => {
//     setCurrentSection(section);
//     navigate(`/VerificationsAdmin?section=${section}`);
//     const closeBtn = document.querySelector(".btn-cus");
//     if (closeBtn) closeBtn.click();
//   };

//   // Handle scrolling when URL changes
//   useEffect(() => {
//     const updatedSection = queryParams.get("section") || "VerifyForm";
//     setCurrentSection(updatedSection);

//     const el = document.getElementById(updatedSection);
//     if (updatedSection && sectionComponents[updatedSection]) {
//       if (el) {
//         const yOffset = -150;
//         const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
//         setTimeout(() => window.scrollTo({ top: y, behavior: "smooth" }), 100);
//       } else {
//         setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
//       }

//       // Collapse Manage Access if not active
//       const isManageAccess = ["Manage-Access", "mn-veri", "Usesr-Roles"].includes(updatedSection);
//       const collapseEl = document.getElementById("collapseTwo");
//       if (collapseEl && !isManageAccess && collapseEl.classList.contains("show")) {
//         collapseEl.classList.remove("show");
//       }
//     } else {
//       setCurrentSection("VerifyForm");
//       const collapseEl = document.getElementById("collapseTwo");
//       if (collapseEl) collapseEl.classList.remove("show");
//       setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
//     }
//   }, [location.search]);

//   const isManageAccessActive = ["Manage-Access", "mn-veri", "Usesr-Roles"].includes(currentSection);

//   // ⚠️ Wait until role is loaded
//   if (role === null) return <p>Loading...</p>;

//   return (
//     <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
//       <div className="container max-1330 mx-auto">
//         <div className="row g-3 g-sm-4 g-md-5">
//           <div className="col-lg-3">
//             <div className="position-sticky top-150">
//               <div className="d-lg-none text-end">
//                 <i
//                   className="bi bi-list border-0 ms-auto font-32"
//                   data-bs-toggle="offcanvas"
//                   data-bs-target="#offcanvasResponsive"
//                   aria-controls="offcanvasResponsive"
//                 ></i>
//               </div>

//               <div className="offcanvas-lg offcanvas-end" tabIndex="-1" id="offcanvasResponsive" aria-labelledby="offcanvasResponsiveLabel">
//                 <div className="offcanvas-header d-lg-none">
//                   <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">Our Services</h5>
//                   <button type="button" className="btn-close btn-cus" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasResponsive" aria-label="Close"></button>
//                 </div>

//                 <div className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible" id="accordionExample">

                  

                 
//                   <div className="accordion-item">
//                     <h2 className="accordion-header">
//                       <button
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#collapseOne"
//                         aria-expanded={currentSection === "VerifyForm"}
//                         aria-controls="collapseOne"
//                         className={`accordion-button noAfter ${currentSection === "VerifyForm" ? "" : "collapsed"}`}
//                         onClick={() => handleClick("VerifyForm")}
//                       >
//                         VERIFICATIONS
//                       </button>
//                     </h2>
//                   </div>

                 
//                   {role === "Admin" && (
//                     <div className="accordion-item">
//                       <h2 className="accordion-header">
//                         <button
//                           className={`accordion-button ${isManageAccessActive ? "" : "collapsed"}`}
//                           type="button"
//                           data-bs-toggle="collapse"
//                           data-bs-target="#collapseTwo"
//                           aria-expanded={isManageAccessActive}
//                           aria-controls="collapseTwo"
//                         >
//                           Manage Access
//                         </button>
//                       </h2>
//                       <div
//                         id="collapseTwo"
//                         className={`accordion-collapse ${isManageAccessActive ? "show" : "collapse"}`}
//                         data-bs-parent="#accordionExample"
//                       >
//                         <div className="accordion-body p-0">
//                           <ul>
//                             <li>
//                               <button
//                                 type="button"
//                                 className={currentSection?.toLowerCase() === "manage-access" ? "active" : ""}
//                                 onClick={() => handleClick("Manage-Access")}
//                               >
//                                 Users
//                               </button>
//                             </li>
//                             <li>
//                               <button
//                                 type="button"
//                                 className={currentSection === "mn-veri" ? "active" : ""}
//                                 onClick={() => handleClick("mn-veri")}
//                               >
//                                 Roles
//                               </button>
//                             </li>
//                             <li>
//                               <button
//                                 type="button"
//                                 className={currentSection === "Usesr-Roles" ? "active" : ""}
//                                 onClick={() => handleClick("Usesr-Roles")}
//                               >
//                                 User Roles
//                               </button>
//                             </li>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9 col-md-8">
//             <div id={currentSection}>
//               {sectionComponents[currentSection] || <Vacancies />}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default VerifyAdminTab;


import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Vacancies from "../OpportunitiesPage/OpportunitiesTabs/Vacancies";
import MartimeCareers from "../OpportunitiesPage/OpportunitiesTabs/MartimeCareers";
import MartimeStudies from "../OpportunitiesPage/OpportunitiesTabs/MartimeStudies";
import Cadetship from "../OpportunitiesPage/OpportunitiesTabs/Cadetship";
import SupplyChainManagement from "../OpportunitiesPage/OpportunitiesTabs/SupplyChainManagement";
import CadetshipTraining from "../OpportunitiesPage/OpportunitiesTabs/CadetshipTraining";
import RFQSubmissions from "../OpportunitiesPage/OpportunitiesTabs/RFQSubmissions";
import FleetManagement from "../OpportunitiesPage/OpportunitiesTabs/FleetManagement";
import OpportunitiesLegislation from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesLegislation";
import OpportunitiesSBDForms from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesSBDForms";
import OpportunitiesGeneralConditions from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesGeneralConditions";
import OpportunitiesCodeOFConduct from "../OpportunitiesPage/OpportunitiesTabs/OpportunitiesCodeOFConduct";

import VerifyForm from "../Verify";
import ManageAccess from "./ManageAccess";
import AdminF from "./AdminF";
import UsesrRoles from "./UsesrRoles";

// Mapping sections to components
const sectionComponents = {
  "VerifyForm": <VerifyForm />,
  "Manage-Access": <ManageAccess />,
  "mn-veri": <AdminF />,
  "vacancies": <Vacancies />,
  "maritime-careers": <MartimeCareers />,
  "cadetship": <Cadetship />,
  "CadetshipTraining": <CadetshipTraining />,
  "supply-chain": <SupplyChainManagement />,
  "maritime-studies": <MartimeStudies />,
  "RFQ-Submissions": <RFQSubmissions />,
  "Fleet-Management": <FleetManagement />,
  "Opportunities-Legislation": <OpportunitiesLegislation />,
  "Usesr-Roles": <UsesrRoles />,
  "Opportunities-GeneralConditions": <OpportunitiesGeneralConditions />,
  "Opportunities-CodeOFConduct": <OpportunitiesCodeOFConduct />,
};

function VerifyAdminTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const initialSection = queryParams.get("section") || "VerifyForm";

  const [currentSection, setCurrentSection] = useState(initialSection);
  const [role, setRole] = useState(null); // null until loaded

  // ✅ Fetch user role from localStorage (set after login)
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
       
     
        setRole(user.role || "NormalUser");
      } catch (err) {
        console.error("Failed to parse user from localStorage", err);
        setRole("NormalUser");
      }
    } else {
      setRole("NormalUser");
    }
  }, []);

  const handleClick = (section) => {
    setCurrentSection(section);
    navigate(`/VerificationsAdmin?section=${section}`);
    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) closeBtn.click();
  };

  // Handle scrolling when URL changes
  useEffect(() => {
    const updatedSection = queryParams.get("section") || "VerifyForm";
    setCurrentSection(updatedSection);

    const el = document.getElementById(updatedSection);
    if (updatedSection && sectionComponents[updatedSection]) {
      if (el) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        setTimeout(() => window.scrollTo({ top: y, behavior: "smooth" }), 100);
      } else {
        setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
      }

      // Collapse Manage Access if not active
      const isManageAccess = ["Manage-Access", "mn-veri", "Usesr-Roles"].includes(updatedSection);
      const collapseEl = document.getElementById("collapseTwo");
      if (collapseEl && !isManageAccess && collapseEl.classList.contains("show")) {
        collapseEl.classList.remove("show");
      }
    } else {
      setCurrentSection("VerifyForm");
      const collapseEl = document.getElementById("collapseTwo");
      if (collapseEl) collapseEl.classList.remove("show");
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
    }
  }, [location.search]);

  const isManageAccessActive = ["Manage-Access", "mn-veri", "Usesr-Roles"].includes(currentSection);

  // ⚠️ Wait until role is loaded
  if (role === null) return <p>Loading...</p>;

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3">
            <div className="position-sticky top-150">
              <div className="d-lg-none text-end">
                <i
                  className="bi bi-list border-0 ms-auto font-32"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasResponsive"
                  aria-controls="offcanvasResponsive"
                ></i>
              </div>

              <div className="offcanvas-lg offcanvas-end" tabIndex="-1" id="offcanvasResponsive" aria-labelledby="offcanvasResponsiveLabel">
                <div className="offcanvas-header d-lg-none">
                  <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">Our Services</h5>
                  <button type="button" className="btn-close btn-cus" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasResponsive" aria-label="Close"></button>
                </div>

                <div className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible" id="accordionExample">

                  

                 
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded={currentSection === "VerifyForm"}
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter ${currentSection === "VerifyForm" ? "" : "collapsed"}`}
                        onClick={() => handleClick("VerifyForm")}
                      >
                        VERIFICATIONS
                      </button>
                    </h2>
                  </div>

                 
                  {role === "Admin" && (
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button ${isManageAccessActive ? "" : "collapsed"}`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded={isManageAccessActive}
                          aria-controls="collapseTwo"
                        >
                          Manage Access
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className={`accordion-collapse ${isManageAccessActive ? "show" : "collapse"}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body p-0">
                          <ul>
                            <li>
                              <button
                                type="button"
                                className={currentSection?.toLowerCase() === "manage-access" ? "active" : ""}
                                onClick={() => handleClick("Manage-Access")}
                              >
                                Users
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className={currentSection === "mn-veri" ? "active" : ""}
                                onClick={() => handleClick("mn-veri")}
                              >
                                Roles
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className={currentSection === "Usesr-Roles" ? "active" : ""}
                                onClick={() => handleClick("Usesr-Roles")}
                              >
                                User Roles
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-8">
            <div id={currentSection}>
              {sectionComponents[currentSection] || <Vacancies />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VerifyAdminTab;
